import { message } from 'antd';

export const formatRole = (role) => {
  return role === 'user' ? 'User' : 'MAIRA™';
};

export const formatDOB = (dob) => {
  if (!dob || dob === 'Not mentioned') return '';
  // Handle ISO datetime format (e.g., "1985-03-15T00:00:00.000-05:00")
  const dateOnly = dob.split('T')[0];
  const [year, month, day] = dateOnly.split('-');
  return `${month}/${day}/${year}`;
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

export const formatTime = (time) => {
  if (!time) return 'N/A';
  return new Date(time).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const formatDuration = (seconds) => {
  if (!seconds) return '00:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export { formatPhoneNumber } from '../../util/phoneNumber';

const capitalizeNameSegment = (segment) => {
  if (!segment) return '';

  const firstChar = segment.charAt(0).toUpperCase();
  const remainder = segment.slice(1);

  if (segment.length <= 3 && /^[A-Z]+$/.test(segment)) {
    return segment;
  }

  if (/^[A-Z]+$/.test(segment)) {
    return firstChar + remainder.toLowerCase();
  }

  if (/^[a-z]+$/.test(segment)) {
    return firstChar + remainder;
  }

  return firstChar + remainder;
};

export const formatName = (name) => {
  if (!name) return '';

  return name
    .trim()
    .split(/\s+/)
    .map((part) => part
      .split(/([-'])/)
      .map((segment, index) => (index % 2 === 0 ? capitalizeNameSegment(segment) : segment))
      .join(''))
    .join(' ');
};

export const copyValue = async (value, successMessage = 'Copied to clipboard', errorMessage = 'Failed to copy to clipboard') => {
  try {
    await navigator.clipboard.writeText(value);
    message.success(successMessage);
  } catch (e) {
    message.error(errorMessage);
  }
};

export const getInitials = (name) => {
  if (!name || !name.trim()) return '-';
  const initials = name
    .trim()
    .split(/\s+/)
    .map((n) => n[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2);
  return initials || '-';
};
